import * as IoC from 'inversify';
import { StateSerializationPluginSymbol } from '@/app/state-serialization/api';
import * as Serialization from '../serialization'
//import { InteractionSuspendDataStore } from './interaction-suspend-data-state-store'
import { InteractionSuspendDataStore2 } from './interaction-suspend-data-state-store2'
//import { QueryInteractionsQueryHandler } from './query-interactions-query-handler';

export const interactionCommonTrackingModule = new IoC.ContainerModule((bind) => {
//  bind(Projection.InteractionStateProjection).toSelf().inSingletonScope();
//  bind(InteractionSuspendDataStore).toSelf().inSingletonScope();
  bind(InteractionSuspendDataStore2).toSelf().inSingletonScope();
//  registerQuery(Api.QueryInteractionsTrackingQueryName, QueryInteractionsQueryHandler, bind);
  bind(StateSerializationPluginSymbol).to(Serialization.InteractionStateProtobufSerializer)
})
